import { SHOWBY_OPTIONS } from '@constants/common/chart/chartConst';
import RadioButtons from '@lib/inputs/RadioButtons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Label } from 'semantic-ui-react';
import { SegmentByContainer } from './styles';

interface IShowByProps {
    showBy: string;
    setShowBy: Function;
    isDrillDownActive: boolean;
    isTagFilterApplied: boolean;
}

function ShowBy(props: IShowByProps) {
    const { showBy, setShowBy, isDrillDownActive } = props;

    return (
        <SegmentByContainer>
            <Label>
                <FormattedMessage id="reports.label.showBy" />
            </Label>
            <RadioButtons
                label={{
                    showRequiredIcon: false,
                    labelClass: [''],
                    ulClass: [''],
                    isLabelVisible: false,
                }}
                inputData={{
                    id: 'showBy',
                    isInputRequired: true,
                    type: 'radio',
                    options: SHOWBY_OPTIONS,
                    value: showBy,
                    liClass: ['text-left'],
                    disabled: isDrillDownActive,
                }}
                legend={{
                    dataInstructions: false,
                }}
                inputActions={{
                    handleFieldChange: value => setShowBy(value),
                }}
            />
        </SegmentByContainer>
    );
}

export default ShowBy;
